import _extends from "@babel/runtime/helpers/esm/extends";
import { blue, blurple, green, grey, orange, red, teal, yellow } from './colors';

/**
 * Palette
 *
 * Demos:
 *
 * - [App bar](https://ui-packages.isbuildingluma.com/ui-core/customization/color/)
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Luma-Design-System?type=design&node-id=41-368&t=IxUvlq6MSGJkgc9h-0)
 */
const palette = {
  common: {
    black: '#091521',
    // text.primary
    white: '#FFFFFF' // background.paper
  },

  grey,
  primary: _extends({}, blurple, {
    contrastText: '#FFFFFF'
  }),
  secondary: _extends({}, orange, {
    contrastText: '#FFFFFF'
  }),
  tertiary: _extends({}, teal, {
    contrastText: '#FFFFFF'
  }),
  quaternary: _extends({}, yellow, {
    contrastText: '#000000'
  }),
  error: _extends({}, red, {
    contrastText: '#FFFFFF'
  }),
  warning: _extends({}, orange, {
    contrastText: '#FFFFFF'
  }),
  success: _extends({}, green, {
    contrastText: '#FFFFFF'
  }),
  info: _extends({}, blue, {
    contrastText: '#FFFFFF'
  }),
  background: {
    default: '#F5F5FF',
    paper: '#FFFFFF'
  },
  text: {
    primary: '#091521',
    secondary: '#626277',
    disabled: '#B2B2C1'
  }
};
export default palette;